import { createContext } from "react"

export interface EditStageContextProps<T extends string = string> {
	editStage: T | undefined
	setEditStage: (value: T | undefined) => void
}

export const EditStageContext = createContext<EditStageContextProps | undefined>(undefined)
